import React from 'react';

interface Props {
  text: string;
  disabled: boolean;
  onClick: () => void;
}

const CTAButton = ({ text, disabled, onClick }: Props) => {
  return (
    <div className="relative flex w-full bg-gray-000 pb-20 before:absolute before:inset-x-0 before:top-0 before:-mt-24 before:h-24 before:bg-[linear-gradient(180deg,rgba(255,255,255,0)_0%,#fff_100%)] before:content-['']">
      <button
        className="relative mx-20 h-56 grow rounded-[80px] bg-blue-600 text-gray-000 typo-title100-semibold disabled:bg-gray-200 disabled:bg-none disabled:text-gray-600  "
        type="button"
        disabled={disabled}
        onClick={onClick}
      >
        {`${text}${disabled ? ' 완료' : ''}`}
      </button>
    </div>
  );
};

export default CTAButton;
